import { Decimal } from 'decimal.js-light';
import { NumberPart } from 'src/actuators/user-input/calculations/caseTwo.ts';
import { ActuatorTypes, QueryParams } from 'src/actuators/user-input/calculations/constants.ts';
import { AttributeUniqValues, RegionsEnum } from 'src/generated/operations.ts';
import { UserInput } from 'src/actuators/user-input/types.ts';

export function handleManual(
    torques: AttributeUniqValues,
    searchParams: URLSearchParams,
    inputState: UserInput,
    type: ActuatorTypes,
    currentRegion: RegionsEnum,
) {
    if (!inputState.force) {
        searchParams.delete(QueryParams.forces);
        searchParams.delete(QueryParams.torques);
        return;
    }

    const torque = new Decimal(inputState.force);
    const filtered = torques.values
        .map(({ value }) => {
            const curr = new Decimal(value.replace(NumberPart, '$1'));
            return {
                value,
                curr,
                distance: curr.minus(torque),
            };
        })
        .filter(({ distance }) => (currentRegion === RegionsEnum.Am
            ? distance.greaterThanOrEqualTo(0) : distance.greaterThan(0)))
        .sort((a, b) => a.distance.cmp(b.distance));

    if (filtered.length > 0) {
        searchParams.set(
            type === ActuatorTypes.Linear ? QueryParams.forces : QueryParams.torques,
            JSON.stringify(filtered.slice(0, 2).map(({ value }) => value)),
        );
    } else {
        searchParams.delete(QueryParams.forces);
        searchParams.delete(QueryParams.torques);
    }
}
